import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ABCDLogo from "../../assets/images/ABC-Service.jpg";
import { AppBar, Box, Container } from "@mui/material";
import "./CustomNavbar.scss";
import { FC, useCallback, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  useAppDispatch,
  useAppSelector,
} from "../../redux-store/CustomReduxHooks";
import {
  T_ValidateSSOOldRes,
  TriggerGenerateSSO_OLD,
} from "../../features/Feature_SSO/Sso_Types";
import {
  E_ChannelOptions,
  T_CustomerLobDetails,
  T_UserProfile,
} from "../../globalTypes/GlobalTypes";
import {
  clearSsoSlice,
  triggerGenerateSSOOld,
} from "../../features/Feature_SSO/Sso_Slice";
import { updateMedicalReportInlineFunClicked } from "../../features/Feature_HealthInsurance/HealthInsurance_Slice";
import {
  EVENT_HANDLER,
  GTAScreenType,
  ONE_LOGIN_DASHBOARD,
  OneLoginLobCode,
  OneLoginRedirectUrl,
  REACT_APP_URL,
  SCREEN_TYPE,
  tabViewPoint,
} from "../../utils/constants";
import { useLazyLogoutApiQuery } from "../../features/Feature_GeneralAppElements/GeneralAppElements_Api";
import {
  getGTAEventScreenType,
  goToSuperAppInfo,
  propagateEvent,
  windowOpen,
  getCMSLink,
  getMobileOperatingSystem,
} from "../../utils/helper";
import { updateLoadingState } from "../../features/Feature_Loading/Loading_Slice";
import useWindowSize from "../../hooks/useWindowSize";
import CustomNetworkImage from "../CustomNetworkImage/CustomNetworkImage";
import { T_GenerateTokenRes } from "../../features/Feature_Login/Login_Types";
import TriggerGTAEvent from "../../utils/GTA";
import { resetSecondaryChannelSlice } from "../../features/Feature_SecondaryChannels/SecondaryChannel_Slice";
import { R_GeneralElementsRoutes, R_HomeRoutes } from "../../utils/Routes";
import { triggerCleverTapEvent } from "../../utils/CleverTap";
import { setHlSuccessMessages } from "../../features/Features_Cms/Feature_Cms_Slice";
import { useLazyFetchHlSuccessMessagesQuery } from "../../features/Features_Cms/Cms_Api";

interface Props {
  className?: string;
}

const Navbar: FC<Props> = ({ className = "" }) => {
  const navigate = useNavigate();
  const ssoSlice = useAppSelector((state) => state.SsoSlice.ssoData);
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const secondaryChannelSlice = useAppSelector(
    (state) => state.SecondaryChannelSlice
  );
  const medicalReportDownloaded = useAppSelector(
    (state) => state.HealthInsuranceSlice.medicalReportDownloaded
  );
  const appDispatch = useAppDispatch();
  const [fetchHlSuccessMessages] = useLazyFetchHlSuccessMessagesQuery();
  const dispatch = useAppDispatch();
  const userDetails = useAppSelector((state) => state.CsAppSlice.userDetails);
  const tokenDetails = useAppSelector((state) => state.CsAppSlice.tokenDetails);
  const { pathname, search } = useLocation();
  const { width } = useWindowSize();
  const [URLSearchParams] = useSearchParams();
  const action = URLSearchParams.get("action") || "";

  const [getLogOutApi] = useLazyLogoutApiQuery();

  const cmsData = useAppSelector((state) => state.CmsSlice.CmsPageVariableData);
  const cmsLogo =
    cmsData.find((i) => i.attributes.cmsType === "ABC Logo")?.attributes.image
      .data?.attributes.url ?? "";

  /**
   * Trigger event to super app
   */
  const triggerEventToSuperApp = () => {
    const backToSuperAppExtraInfo = goToSuperAppInfo(
      tokenDetails as T_GenerateTokenRes,
      userDetails as T_UserProfile & T_CustomerLobDetails
    );
    console.log(backToSuperAppExtraInfo);
    dispatch({
      type: EVENT_HANDLER.GO_TO_SUPER_APP_EVENT,
      payload: backToSuperAppExtraInfo,
    });
  };

  useEffect(() => {
    const os = csAppSlice.NativeDeviceInfo?.deviceName
      ? getMobileOperatingSystem() === "iOS"
        ? "ios"
        : "android"
      : "web";
    if (pathname.includes("/details/hl")) {
      fetchHlSuccessMessages().then((res) => {
        if (res.isSuccess && res.data) {
          const updatedData = res.data.payload.data.map((item) => ({
            ...item,
            attributes: {
              ...item.attributes,
              link: getCMSLink(`${item.attributes.link}`, os),
            },
          }));
          appDispatch(setHlSuccessMessages(updatedData));
        }
      });
    }
  }, []);

  const handleGotoAbcdApp = useCallback(() => {
    if (csAppSlice.channel === E_ChannelOptions.SUPER_APP) {
      triggerEventToSuperApp();
    } else {
      dispatch(updateLoadingState(true));
      getLogOutApi({
        csUserId: "" + userDetails?.CS_USER_ID,
      }).then(async (res) => {
        dispatch({
          type: "USER_LOGOUT",
          payload: { clearLocalStorage: true },
        });
        dispatch(updateLoadingState(false));
      });
    }
  }, []);

  const backBtnFunc = () => {
    handleGTAEvent();
    if (action === "search") {
      navigate(R_HomeRoutes.home);
      return;
    }
    if ("/no-holdings" === pathname || "/onboarding" === pathname) {
      handleGotoAbcdApp();
      return;
    } else if (R_GeneralElementsRoutes.setMpin === pathname) {
      navigate("/", { replace: true });
      return;
    }
    if (medicalReportDownloaded) {
      dispatch(updateMedicalReportInlineFunClicked(true));
    }
    if (
      csAppSlice.channel === E_ChannelOptions.ONE_ABC &&
      `${pathname}${search}` ===
        (ssoSlice as T_ValidateSSOOldRes)?.urlConstructured
    ) {
      dispatch(clearSsoSlice());
      windowOpen(ONE_LOGIN_DASHBOARD, "_self");
      // dispatch(updateLoadingState(true));
      // dispatch(
      //   triggerGenerateSSOOld({
      //     triggerGenerateSSO_Old:
      //       (ssoSlice as TriggerGenerateSSO_OLD).triggerGenerateSSO_Old || true,
      //     ciiNo: ssoSlice.ciiNo,
      //     functionality: "D",
      //     mobileNo: ssoSlice.mobileNo || "",
      //     lobClientId: ssoSlice.lobClientId,
      //     channel: E_ChannelOptions.CSAPP,
      //     sourceLobId: "11",
      //     destinationLobId: OneLoginLobCode,
      //     callbackUrl: `${REACT_APP_URL}/login`,
      //     redirectionUrl: OneLoginRedirectUrl,
      //     appVersion: "1",
      //     panNumber: ssoSlice.panNumber || "",
      //     customerFullName: ssoSlice.customerFullName || "",
      //     customerDob: ssoSlice.customerDob || "",
      //     emailId: ssoSlice.emailId || "",
      //     osVersion: "Windows",
      //     imei: "",
      //     deviceId: "",
      //     userAgent: navigator.userAgent,
      //     clientIpAddress: "",
      //     udp: "",
      //     udp2: "",
      //     udp3: "",
      //     udp4: "",
      //     udp5: "",
      //     udp6: "",
      //     udp7: "",
      //     udp8: "",
      //     udp9: "",
      //     udp10: "",
      //   } as TriggerGenerateSSO_OLD)
      // );
    } else if (
      csAppSlice.channel === E_ChannelOptions.CSAPP &&
      `${pathname}${search}` ===
        (ssoSlice as T_ValidateSSOOldRes)?.urlConstructured
    ) {
      dispatch(clearSsoSlice());
      navigate(R_HomeRoutes.home);
    } else if (
      csAppSlice.channel === E_ChannelOptions.SECONDARY_CHANNEL &&
      `${pathname}${search}` === secondaryChannelSlice?.constructedAppUrl
    ) {
      dispatch(resetSecondaryChannelSlice());
      navigate(R_HomeRoutes.home);
    } else {
      navigate(-1);
    }
  };

  const handleGTAEvent = () => {
    if (pathname.includes("hl")) {
      triggerCleverTapEvent("back_click", {
        ScreenType: SCREEN_TYPE.HFScreenType,
      });
      TriggerGTAEvent("back_click", {
        screen_type: GTAScreenType.HFScreenType,
        screen_name: "Servicing Homescreen",
        isPrevPageNameRequired: true,
      });
    } else if (pathname.includes("li")) {
      triggerCleverTapEvent("back_click", {
        ScreenType: SCREEN_TYPE.LIScreenType,
      });
      TriggerGTAEvent("back_click", {
        screen_type: GTAScreenType.LIScreenType,
        screen_name: "Life Insurance Servicing Detail Screen",
        isPrevPageNameRequired: true,
      });
    } else if (pathname.includes("mutual-fund")) {
      console.log("li", pathname.includes("mutual-fund"));
      triggerCleverTapEvent("back_click", {
        ScreenType: SCREEN_TYPE.MFScreenType,
      });
      TriggerGTAEvent("back_click", {
        screen_type: GTAScreenType.MFScreenType,
        screen_name: "Mutual Funds Servicing Detail Screen",
        isPrevPageNameRequired: true,
      });
    } else if (pathname.includes("my-portfolio")) {
      console.log("li", pathname.includes("my-portfolio"));
      triggerCleverTapEvent("back_click", {
        ScreenType: SCREEN_TYPE.StockScreenType,
      });
      TriggerGTAEvent("back_click", {
        screen_type: GTAScreenType.StockScreenType,
        screen_name: "Stocks & Securities Servicing Detail Screen",
        isPrevPageNameRequired: true,
      });
    } else if (pathname.includes("hi")) {
      console.log("li", pathname.includes("hi"));
      triggerCleverTapEvent("back_click", {
        ScreenType: SCREEN_TYPE.HIScreenType,
      });
      TriggerGTAEvent("back_click", {
        screen_type: GTAScreenType.HI_ScreenType,
        screen_name: "Health Insurance Servicing Detail Screen",
        isPrevPageNameRequired: true,
      });
    } else {
      console.log("li", pathname.includes("hi"));
      triggerCleverTapEvent("back_click", {
        ScreenType: SCREEN_TYPE.DashboardScreenType,
      });
      TriggerGTAEvent("back_click", {
        screen_type: GTAScreenType.DashboardScreenType,
        screen_name: "Servicing Homescreen",
        isPrevPageNameRequired: true,
      });
    }
    // TriggerGTAEvent("back_click", {
    //   screen_type: getGTAEventScreenType(pathname)?.screen_type,
    //   screen_name: getGTAEventScreenType(pathname)?.screen_name,
    // });
  };

  const logoImageStyle = {
    height: "2.75rem",
    width: "7.125rem",
  };

  return (
    <AppBar
      className={`navbar ${className}`}
      position="static"
      sx={{
        backgroundColor: "white",
        boxShadow: "0rem .5rem 1rem 0rem #0000000A",
      }}
    >
      <Container
        sx={{ display: "flex", alignItems: "center", paddingY: ".625rem" }}
      >
        {className !== "from-loading" && (
          <Box className="back-arrow-wrapper" onClick={backBtnFunc}>
            <KeyboardArrowLeftIcon className="back-arrow-icon" />
          </Box>
        )}
        <Box
          display="flex"
          justifyContent={width >= tabViewPoint ? "" : "center"}
          flexGrow={1}
          marginRight={className !== "from-loading" ? "2.5rem" : "0"}
        >
          <CustomNetworkImage
            fallBackImage={<img src={ABCDLogo} alt="" style={logoImageStyle} />}
            src={cmsLogo}
            alt="aditya-birla"
            style={logoImageStyle}
          />
        </Box>
      </Container>
    </AppBar>
  );
};

export default Navbar;
